export default "__VITE_ASSET__CgNrphjM__"